import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-gamification-daily-tips',
  imports: [],
  templateUrl: './gamification-daily-tips.component.html',
  standalone: true
})
export class GamificationDailyTipsComponent {
  @Input() dayIndex: number = 0;
  @Input() username: string = '';
  @Input() selectedDayTip: string | null = null;
}
